import {
  Button,
  ComboBox,
  FormRow,
  Health,
  SuperSelect,
  Text,
  notification,
} from '@antoree/ant-ui';
import { queryClient } from 'AppProvider';
import { COURSE_STATUSES } from 'constants/courses';
import { useCurrentUser } from 'contexts';
import React, { memo, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useRetrieveTimeZone, useUpdateTimeZoneStatus } from 'services/myInfo';
import { RETRIEVE_CURRENT_USER } from 'services/user';

const TimeZone = () => {
  const intl = useIntl();
  const { timeZone } = useCurrentUser();
  const { data, isLoading } = useRetrieveTimeZone({
    refetchOnMount: false,
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
  });
  const { mutate, isLoading: isLoadingTimeZone } = useUpdateTimeZoneStatus({
    onSuccess: () => {
      notification.success({
        title: (
          <FormattedMessage defaultMessage="Update time zone successful" />
        ),
      });

      queryClient.invalidateQueries([RETRIEVE_CURRENT_USER]);
    },
    onError: error => {
      notification.error({
        title: <FormattedMessage defaultMessage="Update time zone failed" />,
        text: <p>{error?.response?.data?.errors[0]?.message}</p>,
      });
    },
  });

  const [selectedOptions, setSelected] = useState<any[]>([{ label: timeZone }]);
  const onChange = (selectedOptions: any) => {
    setSelected(selectedOptions);

    mutate({
      timeZone: selectedOptions[0]?.label,
    });
  };
  useEffect(() => {
    setSelected([{ label: timeZone }]);
  }, [timeZone]);
  return (
    <div>
      <FormRow label={<FormattedMessage defaultMessage="Time Zone" />} required>
        <div className="rounded-lg w-56">
          <ComboBox
            placeholder={intl.formatMessage({ defaultMessage: 'Time zone' })}
            singleSelection={true}
            options={
              data?.data?._data?.timezone
                ? Object.keys(data?.data?._data?.timezone)
                    ?.map(item =>
                      Object.keys(data?.data?._data?.timezone[item]),
                    )
                    .reduce((a: any, b: any) => [...a, ...b])
                    .map(stt => ({
                      label: stt,
                    }))
                : []
            }
            selectedOptions={selectedOptions}
            onChange={onChange}
            isClearable
            isLoading={isLoadingTimeZone}
            isDisabled
          />
        </div>
      </FormRow>
    </div>
  );
};

export default memo(TimeZone);
